import { useEffect, useState, useContext } from 'react';
import CommonTable from '../common/commonTable/CommonTable';
import { categoryCrud, exportCategory } from '../../api/category';
import CategoryModal from './CategoryModal';
import ReactNotifications from '../common/reactNotifications/ReactNotifications';
import * as utilConstants from "../../utils/constants/utilsConstants";
import DeleteModal from '../common/commonModal/DeleteModal';
import PaginationComponent from '../common/pagination/Pagination';
import { useSearchParams, useLocation, useNavigate } from 'react-router-dom';
import Context from '../../context/Context';

const Category = ({ filters: propFilters, setFilters: propSetFilters, disableTitleUpdate }) => {
    const [categories, setCategories] = useState([]);
    const { setPageTitle } = useContext(Context);
    const location = useLocation();
    const navigate = useNavigate();

    const [internalFilters, setInternalFilters] = useState({});
    const filters = propFilters !== undefined ? propFilters : internalFilters;
    const setFilters = propSetFilters !== undefined ? propSetFilters : setInternalFilters;

    const columns = [
        { header: 'Category Name', accessor: 'category_name' },
        { header: 'Category Code', accessor: 'category_code' },
    ];
    
    const [showCategoryModal, setShowCategoryModal] = useState(false);
    const [editingCategory, setEditingCategory] = useState(null);

    const [showDelModal, setShowDelModal] = useState(false);
    const [delRow, setDelRow] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    const [hasFetched, setHasFetched] = useState(false);
    
    const itemsPerPage = 10;
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        const { searchQuery } = location.state || {};
        if (searchQuery) {
            setFilters({ search: searchQuery });
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, [location.state, navigate, setFilters]);

    const handlePageChange = (page) => {
        setSearchParams({ p: page });
        setCurrentPage(page);
    };

    const handleDeleteClick = (row) => {
        setDelRow(row);
        setShowDelModal(true);
    };

    const handleDelete = () => {
        if (delRow?.id) {
            categoryCrud(delRow, 'delete', (res) => {
                if (res?.status === true) {
                    ReactNotifications(res?.message, utilConstants.sucessState200);
                    fetchAllCategories(currentPage, filters);
                    setShowDelModal(false);
                } else {
                    ReactNotifications(res?.data?.message, utilConstants.getErrorStatus);
                }
            })
        }
    };

    const handleAddClick = () => {
        setEditingCategory(null);
        setShowCategoryModal(true);
    };

    const handleEditClick = (row) => {
        setEditingCategory(row);
        setShowCategoryModal(true);
    };

    const handleModalSaveSuccess = () => {
        const pageToFetch = editingCategory ? currentPage : 1;
        fetchAllCategories(pageToFetch, filters);
    };

    const fetchAllCategories = (page, appliedFilters) => {
        setLoading(true);
        const payload = { page, ...appliedFilters };
        categoryCrud(payload, 'get', (response) => {
            if (response?.status === true) {
                setTotalCount(response?.count);
                setCategories(response?.data);
            }
            setLoading(false);
            setHasFetched(true);
        });
    }

    const handleDownload = () => {
        exportCategory({}, () => {
        });
    }

    useEffect(() => {
        if (!disableTitleUpdate) {
            setPageTitle('Categories');
        }
        const pageFromUrl = parseInt(searchParams.get('p')) || 1;
        setCurrentPage(pageFromUrl);
    }, [setPageTitle, searchParams, disableTitleUpdate]);

    useEffect(() => {
        fetchAllCategories(currentPage, filters);
    }, [currentPage, filters]);

    return (
        <section>
            <div className='px-4'>
                <CommonTable
                    columns={columns}
                    data={categories}
                    actions={['edit', 'delete']}
                    onAdd={handleAddClick}
                    onEdit={handleEditClick}
                    onDelete={handleDeleteClick}
                    addButtonText="Add"
                    loading={loading}
                    hasFetched={hasFetched}
                    isExport={true}
                    handleDownload={handleDownload}
                    sortAble={true}
                    sortedCol={['category_name']}
                    idAccessor="id"
                />
                {totalCount > 10 && <PaginationComponent
                    currentPage={currentPage}
                    totalCount={totalCount}
                    itemsPerPage={itemsPerPage}
                    onPageChange={handlePageChange}
                />}
                <CategoryModal
                    show={showCategoryModal}
                    onHide={() => setShowCategoryModal(false)}
                    initialData={editingCategory}
                    onSaveSuccess={handleModalSaveSuccess}
                />
                <DeleteModal
                    show={showDelModal}
                    onClose={() => setShowDelModal(false)}
                    onConfirm={handleDelete}
                    title="Delete Category"
                    message="Are you sure you want to delete this category? This action cannot be undone."
                />
            </div>
        </section>
    )
}

export default Category;